import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _defaultTo from 'lodash/defaultTo';
/* eslint-disable react/no-multi-comp, react/prefer-stateless-function, react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';


import { defaultSize, sizes, devices, defaultDevice } from '../constants';
import { Consumer } from '../context';

var MediaConsumer = function (_Component) {
  _inherits(MediaConsumer, _Component);

  function MediaConsumer() {
    _classCallCheck(this, MediaConsumer);

    return _possibleConstructorReturn(this, (MediaConsumer.__proto__ || _Object$getPrototypeOf(MediaConsumer)).apply(this, arguments));
  }

  _createClass(MediaConsumer, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React.createElement(
        Consumer,
        null,
        function (media) {
          return _this2.props.children({
            size: _defaultTo(media.size, _this2.props.defaultSize),
            touchable: _defaultTo(media.touchable, _this2.props.defaultTouchable),
            landscape: _defaultTo(media.landscape, _this2.props.defaultLandscape),
            device: _defaultTo(media.device, _this2.props.defaultDevice)
          });
        }
      );
    }
  }]);

  return MediaConsumer;
}(Component);

MediaConsumer.propTypes = {
  /**
   *  - Sizes:
   *     - 100 -> min: 0px, max: 360px,
   *     - 200 -> min: 360px, max: 480px,
   *     - 300 -> min: 480px, max: 768px,
   *     - 400 -> min: 768px, max: 1024px,
   *     - 500 -> min: 1024px, max: 1280px,
   *     - 600 -> min: 1280px, max: 1366px,
   *     - 700 -> min: 1366px, max: 1600px,
   *     - 800 -> min: 1600px, max: Infinity,
   */
  defaultSize: PropTypes.oneOf(sizes),
  /** Decide whether device is touchable or not */
  defaultTouchable: PropTypes.bool,
  /** Decide whether device is landscape or portrait */
  defaultLandscape: PropTypes.bool,
  /**
   * - Devices:
   *     - mobile,
   *     - tablet,
   *     - desktop,
   *     - native,
   */
  defaultDevice: PropTypes.oneOf(devices),
  /** The MediaConsumer's children */
  children: PropTypes.func.isRequired
};
MediaConsumer.defaultProps = {
  defaultSize: defaultSize,
  defaultTouchable: false,
  defaultLandscape: false,
  defaultDevice: defaultDevice
};
export default MediaConsumer;